import { ReactComponent as VigboBreadcrumbActive } from 'img/icons/vigbo/vigbo-breadcrumb-active.svg';
import { ReactComponent as VigboBreadcrumbFinishedDark } from 'img/icons/vigbo/vigbo-breadcrumb-finished-dark.svg';
import { ReactComponent as VigboBreadcrumbFinishedLight } from 'img/icons/vigbo/vigbo-breadcrumb-finished-light.svg';
import React from 'react';
import { forceVigboLinkedAccount } from 'reactApp/appHelpers/featuresHelpers/features/vigbo';

import { VigboAccountLinkState } from './vigbo.types';

export const getVigboBreadcrumbsIconSettings = ({
    linkState,
    isVigboActiveTariff,
    isDarkTheme,
}: {
    linkState: VigboAccountLinkState;
    isVigboActiveTariff: boolean;
    isDarkTheme: boolean;
}) => {
    return {
        showIcon: linkState === VigboAccountLinkState.linked || forceVigboLinkedAccount,
        iconName: isVigboActiveTariff ? 'vigbo_linked' : 'vigbo_finished',
        icon: isVigboActiveTariff ? (
            <VigboBreadcrumbActive />
        ) : isDarkTheme ? (
            <VigboBreadcrumbFinishedDark />
        ) : (
            <VigboBreadcrumbFinishedLight />
        ),
    };
};
